module.exports = __webpack_public_path__ + "img/blog-internet-speed.23332603.png";